import { render, staticRenderFns } from "./registration-progress.vue?vue&type=template&id=aa6df276&scoped=true"
import script from "./registration-progress.vue?vue&type=script&lang=js"
export * from "./registration-progress.vue?vue&type=script&lang=js"
import style0 from "./registration-progress.vue?vue&type=style&index=0&id=aa6df276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6df276",
  null
  
)

export default component.exports